import { jsx as r } from "react/jsx-runtime";
import { n as l } from "../chunks/array.c8fbbd1f.js";
import m, { useState as v, useEffect as f } from "react";
import { styled as n, css as g } from "styled-components";
const u = n.div.withConfig({
  displayName: "Container",
  componentId: "sc-1vxaogb-0"
})(["all:unset;display:flex;align-items:center;"]), p = n.div.withConfig({
  displayName: "Element",
  componentId: "sc-1vxaogb-1"
})(["display:flex;justify-content:center;align-items:center;width:var(--size-2x);height:var(--size-2x);&::after{content:'';display:block;width:var(--size-half);height:var(--size-half);border-radius:var(--border-radius-circular);background:var(--elements-icon-color);transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-02);}", ""], ({
  selected: t
}) => t && g`
      &::after {
        width: var(--size-1x);
        height: var(--size-1x);
        background: var(--selected-icon-color);
      }
    `), h = m.forwardRef(({
  items: t = 0,
  selectedItem: e = 0,
  ...o
}, i) => {
  const [s, c] = v(e);
  f(() => {
    c(e);
  }, [e]);
  const d = () => l(t).map((a) => /* @__PURE__ */ r(p, { selected: s === a, "data-testid": `rango-nav-control-item-${a}` }, a));
  return /* @__PURE__ */ r(u, { ref: i, "data-testid": "rango-nav-control", "data-rango-component": "rango-nav-control", "data-is-rango": !0, ...o, children: t > 0 && d() });
});
h.displayName = "RangoNavControl";
export {
  h as RangoNavControl
};
